import { Api } from "../axios-config";
import { CapitalizationData } from "./types";

interface CapitalizationListResponse {
	data: CapitalizationData[];
	total: number;
	page: number;
	limit: number;
	totalPages: number;
}

const getCapitalizationAll = async (
	page = 1,
	limit = 10,
	search = "",
	dataini = "",
	datafim = "",
	status = "",
	clientId = ""
): Promise<CapitalizationListResponse | Error> => {
	try {
		const normalizedStatus = status === "todos" ? "" : status;

		const response = await Api().get<CapitalizationListResponse>(`/capitalization/`, {
			params: {
				_page: page,
				_limit: limit,
				name: search || undefined,
				status: normalizedStatus || undefined,
				dataini: dataini || undefined,
				datafim: datafim || undefined,
				clientId: clientId || undefined,
			},
		});

		const { data, headers } = response;

		if (Array.isArray(data?.data) || Array.isArray((data as any)?.results)) {
			const list = data.data || (data as any).results;
			return {
				data: list,
				total: data.total || list.length,
				page: data.page ?? page,
				limit: data.limit ?? limit,
				totalPages: data.totalPages ?? Math.ceil((data.total || list.length) / (data.limit ?? limit)),
			};
		}

		// Tratamento para quando a API retorna o array diretamente ou vazio (ex: 304)
		if (Array.isArray(data) || !data) {
			const list = Array.isArray(data) ? data : [];
			return {
				data: list,
				total: list.length,
				page: page,
				limit: limit,
				totalPages: Math.ceil(list.length / limit) || 1,
			};
		}

		return new Error("Formato de retorno inesperado da API.");
	} catch (error: any) {
		console.error("Erro ao buscar eventos de incêndio:", error);
		return new Error(error.message || "Erro ao buscar eventos de incêndio.");
	}
};

const create = async (data: Omit<CapitalizationData, "id">): Promise<string | Error> => {
	try {
		const { data: responseData } = await Api().post("/capitalization", data);
		return responseData.id;
	} catch (error: any) {
		console.error("Erro ao criar capitalização:", error);
		return new Error(error.message || "Erro ao criar capitalização.");
	}
};

const getById = async (id: string): Promise<CapitalizationData | Error> => {
	try {
		const { data } = await Api().get(`/capitalization/${id}`);
		return data;
	} catch (error: any) {
		console.error("Erro ao buscar capitalização por ID:", error);
		return new Error(error.message || "Erro ao buscar capitalização por ID.");
	}
};

const update = async (id: string, data: Partial<CapitalizationData>): Promise<void | Error> => {
	try {
		await Api().patch(`/capitalization/${id}`, data);
	} catch (error: any) {
		console.error("Erro ao atualizar capitalização:", error);
		return new Error(error.message || "Erro ao atualizar capitalização.");
	}
};

export const CapitalizationService = {
	getCapitalizationAll,
	create,
	getById,
	update,
};
